module.exports = __webpack_public_path__ + "static/media/video-clipper-logo.549b4087.svg";